import { FC } from 'react'
import { AdditionalServicesAttachments } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesAttachmentsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesAttachments />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesAttachmentsPage
